import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../constant';
import { getNotificationOriginName, getSessionStorage, removeSessionStorage, setSessionStorage } from '../../utils';
import { v3_profile_detail } from '../../actions/v3/user';
import { useGlobalData } from '../../context/GlobalDataContext';
import { useNotificationContext } from '../../context/NotificationContext';
import moment from 'moment';
const Header = ({ sidebarStatus }) => {
    const { globalData } = useGlobalData();
    const { notifications, unreadCount, markAsRead, markAllAsRead, clearNotifications } = useNotificationContext();

    const history = useHistory()
    const [isSidebarEnabled, setSidebarEnabled] = useState(sidebarStatus);
    const [ud, set_ud] = useState({})
    const topNotifications = notifications.slice(0, 8);
    const companyLogoUrl = globalData?.COMPANY_LOGO
        ? `${process.env.REACT_APP_BASE_URL}/v1/globalSettings/${globalData.COMPANY_LOGO}`
        : null;

    useEffect(() => {
        if (getSessionStorage(constant.keys.userDetails)) {
            set_ud(JSON.parse(atob(getSessionStorage(constant.keys.userDetails))))
        }
        else {

            v3_profile_detail().then((res) => {
                if (res.status) {
                    set_ud(JSON.parse(atob(res.result)))
                    setSessionStorage(constant.keys.userDetails, res.result)

                }
            })
        }

    }, [])
    const toggleSidebar = () => {
        setSidebarEnabled(!isSidebarEnabled);
    };

    useEffect(() => {
        if (isSidebarEnabled) {
            document.body.classList.add('sidebar-enable', 'vertical-collpsed');
        } else {
            document.body.classList.remove('sidebar-enable', 'vertical-collpsed');
        }
    }, [isSidebarEnabled]);

    const getFullScreenElement = () => {
        return document.fullscreenElement
            || document.webkitFullscreenElement
            || document.mozFullscreenElement
            || document.msFullscreenElement;
    }

    const toggleFullScreen = () => {
        if (getFullScreenElement()) {
            document.exitFullscreen().catch((e) => {
                console.error(e);
            });
        } else {
            document.documentElement.requestFullscreen().catch((e) => {
                console.error(e);
            });
        }
    }

    const lockScreen = (e) => {
        e.preventDefault();
        // removeStorage(constant.keys.userToken);
        removeSessionStorage(constant.keys.userToken);

        window.location.href = constant.nonAuthedcomponent.lockScreen.url;
    }

    const openNotification = (notification) => {
        markAsRead(notification.id);
        if (notification.link) {
            history.push(notification.link);
        }
    };

    return (
        <header id="page-topbar" style={{ backgroundColor: "#ffffff" }}>
            <div className="navbar-header">
                <div className="d-flex">
                    {/* LOGO */}
                    <div className="navbar-brand-box">
                        <Link
                            to={constant.Authedcomponent.dashboard.url}
                            className="logo logo-dark"
                        >
                            <span className="logo-sm">
                                <img
                                    src={companyLogoUrl}
                                    style={{ width: 112, marginBottom: 5, marginRight: 0 }}
                                />
                            </span>
                            <span
                                className="logo-lg"
                                style={{ fontSize: 21, color: "#9ec035", fontFamily: "oswald" }}
                            >
                                <span
                                    className=""
                                    style={{
                                        color: "#fefcac",
                                        fontFamily: "nunito",
                                        fontSize: 22,
                                        fontWeight: 700
                                    }}
                                >
                                    <img
                                        src={companyLogoUrl}
                                        style={{ width: 112, marginBottom: 5, marginRight: 0 }}
                                    />
                                </span>
                                {/* <img src="assets/images/logo-light.png" alt="" height="19"> */}
                            </span>
                        </Link>
                        <Link
                            to={constant.Authedcomponent.dashboard.url}
                            className="logo logo-light"
                        >
                            <span className="logo-sm">
                                <img src={companyLogoUrl} alt="" height={22} />
                            </span>
                            <span
                                className="logo-lg"
                                style={{ fontSize: 21, color: "#9ec035", fontFamily: "oswald" }}
                            >
                                <span
                                    className=""
                                    style={{
                                        color: "#fefcac",
                                        fontFamily: "nunito",
                                        fontSize: 22,
                                        fontWeight: 700
                                    }}
                                >
                                    <img
                                        src={companyLogoUrl}
                                        style={{
                                            width: 178,
                                            marginBottom: 5,
                                            marginRight: 0,
                                            background: "#FFF",
                                            borderRadius: 5,
                                            padding: 3,
                                            maxHeight: 65
                                        }}
                                    />
                                </span>
                            </span>
                        </Link>
                    </div>
                    {/* <button
                        type="button"
                        className="btn btn-sm px-3 font-size-16 header-item waves-effect"
                        id="vertical-menu-btn"
                    >
                        <i className="fa fa-fw fa-bars" style={{ color: "#2a5a7b" }} />
                    </button> */}
                    {/* App Search*/}
                    <form className="app-search d-none d-lg-block">
                        <div className="position-relative">
                            <button
                                type="button"
                                className="btn btn-info"
                                id="clearlasttoast"
                                style={{
                                    backgroundImage: "linear-gradient(90deg, rgb(106 151 182), rgb(41 87 123))",
                                    fontSize: 16,
                                    fontFamily: "Oswald"
                                }}
                            >
                                NEW-BUILDING SHIP SITE MANAGEMENT 1.1.0
                            </button>

                        </div>
                    </form>
                </div>
                <div className="d-flex">
                    <div className="dropdown d-none d-lg-inline-block ms-1">
                        <button
                            type="button"
                            className="btn header-item noti-icon waves-effect position-relative d-flex align-items-center"
                            title="Check Mail"
                            style={{ gap: "6px", whiteSpace: "nowrap" }}
                            onClick={() => {
                                history.push(constant.Authedcomponent.mailBox.url);
                            }}
                        >
                            <i className="bx bxs-envelope" style={{ color: "#2a5a7b", fontSize: "22px" }} />
                            <span style={{ color: "#2a5a7b" }}>Check Mail</span>
                            {unreadCount > 0 && (
                                <span
                                    className="position-absolute badge rounded-pill bg-danger"
                                    style={{
                                        top: "8px",
                                        right: "4px",
                                        fontSize: "10px",
                                        minWidth: "18px",
                                        height: "18px",
                                        lineHeight: "18px",
                                        padding: "0 5px"
                                    }}
                                >
                                    {unreadCount > 9 ? "9+" : unreadCount}
                                </span>
                            )}
                        </button>
                    </div>

                    <div className="dropdown d-none d-lg-inline-block ms-1">
                        <button
                            type="button"
                            className="btn header-item noti-icon waves-effect position-relative"
                            id="page-header-notification-dropdown"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <i className="bx bx-bell" style={{ color: "#2a5a7b", fontSize: "22px" }} />
                            {unreadCount > 0 && (
                                <span
                                    className="position-absolute badge rounded-pill bg-danger"
                                    style={{
                                        top: "14px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        fontSize: "10px",
                                        minWidth: "18px",
                                        height: "18px",
                                        lineHeight: "18px",
                                        padding: "0 5px"
                                    }}
                                >
                                    {unreadCount > 9 ? "9+" : unreadCount}
                                </span>
                            )}
                        </button>
                        <div
                            className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                            aria-labelledby="page-header-notification-dropdown"
                            style={{ minWidth: "360px" }}
                        >
                            <div className="p-3 d-flex justify-content-between align-items-center border-bottom">
                                <h6 className="m-0" style={{ color: "#2a5a7b" }}>Notifications</h6>
                                <div className="d-flex align-items-center gap-2">
                                    {unreadCount > 0 && (
                                        <button
                                            type="button"
                                            className="btn btn-link btn-sm p-0"
                                            onClick={markAllAsRead}
                                        >
                                            Mark all read
                                        </button>
                                    )}
                                    {notifications.length > 0 && (
                                        <button
                                            type="button"
                                            className="btn btn-link btn-sm p-0 text-danger"
                                            onClick={clearNotifications}
                                        >
                                            Clear all
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div style={{ maxHeight: "320px", overflowY: "auto" }}>
                                {topNotifications.length === 0 && (
                                    <div className="p-3 text-muted small">No notifications yet.</div>
                                )}
                                {topNotifications.map((notification) => {
                                    const originName = getNotificationOriginName(notification);
                                    return (
                                    <button
                                        key={notification.id}
                                        type="button"
                                        className={`dropdown-item border-bottom ${notification.read ? '' : 'bg-light'}`}
                                        onClick={() => openNotification(notification)}
                                        style={{ whiteSpace: "normal" }}
                                    >
                                        <div className="d-flex justify-content-between">
                                            <span className="fw-semibold">{notification.title}</span>
                                            <small className="text-muted">{moment(notification.createdAt).fromNow()}</small>
                                        </div>
                                        {originName && (
                                            <div className="small mt-1" style={{ color: "#2a5a7b" }}>
                                                From: {originName}
                                            </div>
                                        )}
                                        <div className="small text-muted">{notification.message}</div>
                                    </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="dropdown d-none d-lg-inline-block ms-1">
                        <button onClick={() => { toggleFullScreen() }}
                            type="button"
                            className="btn header-item noti-icon waves-effect"
                            data-bs-toggle="fullscreen"
                        >
                            <i className="bx bx-fullscreen" style={{ color: "#2a5a7b" }} />
                        </button>
                    </div>
                    <div className="dropdown d-inline-block ms-1">
                        <button onClick={() => { history.push(constant.Authedcomponent.manual.url) }}
                            type="button"
                            className="btn header-item noti-icon waves-effect"
                            title="User Manual"
                        >
                            <i className="bx bx-book-open" style={{ color: "#2a5a7b" }} />
                        </button>
                    </div>
                    <div className="dropdown d-inline-block">
                        <button
                            type="button"
                            className="btn header-item waves-effect"
                            id="page-header-user-dropdown"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <img
                                className="rounded-circle header-profile-user"
                                src={ud.profileImageUrl
                                    ? process.env.REACT_APP_BASE_URL + ud.profileImageUrl
                                    : `${process.env.REACT_APP_BASE_URL}/v1/globalSettings/${globalData?.DEFAULT_PROFILE_PIC}`}
                                alt={ud.fullName}
                            />
                            <span
                                className="d-none d-xl-inline-block ms-1"
                                style={{ color: "#2a5a7b" }}
                                key="t-henry"
                            >
                                {ud.fullName}

                            </span>
                            <i
                                className="mdi mdi-chevron-down d-none d-xl-inline-block"
                                style={{ color: "#2a5a7b" }}
                            />
                        </button>
                        <div className="dropdown-menu dropdown-menu-end">
                            {/* item*/}
                            {/* <a class="dropdown-item" href="profile.php"><i class="bx bx-user font-size-16 align-middle me-1"></i> <span key="t-profile">Profile</span></a> */}
                            <Link className="dropdown-item d-block" to={constant.Authedcomponent.updateProfile.url}>
                                <i className="bx bx-wrench font-size-16 align-middle me-1" />{" "}
                                <span key="t-settings">Update Profile</span>
                            </Link>
                            <Link className="dropdown-item d-block" to={constant.Authedcomponent.mailBoxConfigure.url}>
                                <i className="bx bxs-envelope font-size-16 align-middle me-1" />{" "}
                                <span key="t-settings">Mail Settings</span>
                            </Link>
                            <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => { lockScreen(e) }}
                            >
                                <i className="bx bx-lock-open font-size-16 align-middle me-1" />{" "}
                                <span key="t-lock-screen">Lock screen</span>
                            </a>
                            <div className="dropdown-divider" />
                            <Link className="dropdown-item text-danger" to={constant.Authedcomponent.logout.url}>
                                <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />{" "}
                                <span key="t-logout">Logout</span>
                            </Link>
                        </div>
                    </div>
                    <div className="dropdown d-inline-block">
                        <button
                            type="button"
                            className="btn header-item noti-icon waves-effect"
                        >
                            <i className="bx bx-cog bx-spin" style={{ color: "#2a5a7b" }} />
                        </button>
                    </div>
                </div>
            </div>
        </header>


    )
}

export default Header
